<template>
  <div class="order-status-graph" >
    <div v-if="orderStatus === 'in-progress'" class="graph graph-in-progress clearfix">
      <div class="dot filled current"><div>{{inProgressStatus}}</div></div>
      <div class="bar"></div>
      <div class="dot"><div>{{shippedStatus}}</div></div>
    </div>
    <div v-if="orderStatus === 'partial-shipment'" class="graph graph-partial-shipment clearfix">
      <div class="dot filled completed"><div>{{inProgressStatus}}</div></div>
      <div class="bar filled "></div>
      <div class="dot filled current"><div>{{partialShipmentStatus}}</div></div>
      <div class="bar"></div>
      <div class="dot"><div>{{shippedStatus}}</div></div>
    </div>
    <div v-if="orderStatus === 'shipped'" class="graph graph-shipped clearfix">
      <div class="dot filled completed"><div>{{inProgressStatus}}</div></div>
      <div class="bar filled"></div>
      <div class="dot filled current"><div>{{shippedStatus}}</div></div>
    </div>
    <div v-if="orderStatus === 'canceled'" class="graph graph-canceled clearfix">
      <div class="dot filled completed"><div>{{inProgressStatus}}</div></div>
      <div class="bar filled"></div>
      <div class="dot filled current"><div>{{canceledStatus}}</div></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'order-status-graph',
    data () {
      return {
        inProgressStatus: this.$t('orders.status.in-progress'),
        partialShipmentStatus: this.$t('orders.status.partial-shipment'),
        shippedStatus: this.$t('orders.status.shipped'),
        canceledStatus: this.$t('orders.status.canceled')

      }
    },
    props: ['order-status'],
    computed: {
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '~scss/variables';

  .order-status-graph {
    position: relative;
    padding: 0 5px;
    text-align: center;

    .graph  {
      display: inline-block;
      height: 75px;

      .bar {
        float: left;
        height: 10px;
        width: 100px;
        background-color: $grey-30;
        margin-top: calc((30px / 2) - (10px / 2));
        margin-left: -3px;
        margin-right: -3px;
      }

      .dot {
        position: relative;
        float: left;
        padding-top: 40px;
        width: 30px;
        color: $grey-50;

        &:before {
          // Rounded form handling
          content: "";
          display: block;
          position: absolute;
          top: 0 ;
          left: 50%;
          margin-left: -15px;
          min-width: 30px;
          height: 30px;
          border-radius: 50%;
          background-color: $grey-30;

          // Icon handling
          font-family: "Material Icons";
          color: $body-light;
          line-height: 30px;
          font-size: 20px;
        }

        > div {
          display: block;
          position: absolute;
          width: 80px;
          top: 40px ;
          left: -25px; // 40px (text's half width) - 15px (dot's half width)
          font-size: 11px;
          font-weight: bold;
        }

        &.current:before {
          content: "\E3FA";
        }
        &.completed:before {
          content: "\E5CA";
        }
      }

      &.graph-in-progress {
        .dot.filled{
          &:before {
            background-color: $success-light;
          }
          &.current > div {
            color: $success-light;
          }
        }
        .bar.filled {
          background-color: $success-light;
        }
      }
      &.graph-partial-shipment{
        .dot.filled {
          &:before {
            background-color: $success-medium;
          }
          &.current > div {
            color: $success-medium;
          }
        }
        .bar.filled {
          background-color: $success-medium;
        }
      }
      &.graph-shipped {
        .dot.filled {
          &:before {
            background-color: $success-strong;
          }
          &.current > div {
            color: $success-strong;
          }
        }
        .bar.filled {
          background-color: $success-strong;
        }
      }
      &.graph-canceled {
        .dot.filled {
          &:before {
            background-color: $danger;
          }
          &.current > div {
            color: $danger;
          }
        }
      }
      .bar.filled {
        background-color: $danger;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// OrderStatusGraph.vue?32c9f39e